const toStorageBalanceFormat = (
  data: Record<string, number>,
): { item: string; value: number }[] =>
  Object.entries(data).map(([item, value]) => ({ item, value }));

export { toStorageBalanceFormat };
